/** Primary conversion landing (sign up / play / external platform). */
export const CTA_URL = "https://ace996au.com/RFLAANDINGPAGE";
